export const bannerHeight = 56;
export const BANNER_NAME = 'IP_BLOCK_LISTING_BANNER';
